if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      connectedCallback() {
        if (super.connectedCallback) super.connectedCallback();
        this.guardDialog();
      }

      guardDialog() {
        const dialog = this.querySelector('.pmm-dialog');
        if (!dialog || dialog.dataset.pmmGuard === 'true') return;
        dialog.dataset.pmmGuard = 'true';

        ['pointerup', 'pointerdown', 'click'].forEach((type) => {
          dialog.addEventListener(type, (event) => {
            const closeBtn = event.target.closest('.pmm-close, [id^="ModalClose-"]');
            if (closeBtn) {
              if (type === 'click') this.hide();
              return;
            }
            event.stopPropagation();
          });
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.guardDialog();
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;

        let slide = null;
        if (mediaId) {
          const el = this.querySelector(`[data-media-id="${mediaId}"]`);
          if (el) slide = el.closest('.pmm-slide') || el;
        }
        if (!slide) slide = this.querySelector('.pmm-slide');
        if (!slide) return;

        const index = parseInt(slide.dataset.index || '0', 10);

        this.querySelectorAll('.pmm-slide').forEach((s, n) => {
          s.classList.toggle('is-active', n === index);
          s.classList.toggle('active', n === index);
          const img = s.querySelector('.pmm-img');
          if (img) {
            img.classList.remove('is-zoomed');
            img.style.transformOrigin = 'center center';
          }
        });

        this.querySelectorAll('.pmm-thumb').forEach((t, n) => {
          t.classList.toggle('is-active', n === index);
        });

        const counter = this.querySelector('.pmm-current');
        if (counter) counter.textContent = index + 1;

        const stage = this.querySelector('.pmm-stage');
        if (stage) {
          stage.scrollTop = 0;
          stage.scrollLeft = 0;
        }

        this.dispatchEvent(new CustomEvent('pmm:goto', { detail: { index } }));

        const activeMediaTemplate = slide.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        const deferred = slide.querySelector('deferred-media') || (slide.nodeName === 'DEFERRED-MEDIA' ? slide : null);

        if (deferred && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) {
          deferred.loadContent();
        }
      }
    }
  );
}